import type { SchedulingVendor } from '@prisma/client';

import type { Flags } from 'components/utils/FeatureFlags';

export const isFeatureFlagEnabled = (
  flags: Flags | undefined,
  feat: string,
  orgId?: string | null,
  userId?: string | null,
  vendor?: SchedulingVendor | null,
) => {
  const flagInfo = flags?.[feat];

  if (flagInfo) {
    if (userId && flagInfo.users && flagInfo.users[userId] !== undefined) {
      return flagInfo.users[userId] === '1';
    }

    if (orgId && flagInfo.orgs && flagInfo.orgs[orgId] !== undefined) {
      return flagInfo.orgs[orgId] === '1';
    }

    if (vendor && flagInfo.vendors && flagInfo.vendors[vendor] !== undefined) {
      return flagInfo.vendors[vendor] === '1';
    }

    return flagInfo.enabled === '1';
  }
  return false;
};
